import { jsx as _jsx } from "react/jsx-runtime";
import NotificationPopover from './NotificationPopover';
export default function Header() {
    return (_jsx("header", { className: "app-header", children: _jsx("div", { className: "header-actions", children: _jsx(NotificationPopover, {}) }) }));
}
